function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../../reducers/modal.reducer';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import MetaDataEdit from './MetaDataEdit.react';
import MetaDataAddRoute from './MetaDataAddRoute.react';
import Label from '../../common/form/Label.react';
import Table from '../../common/table/Table.react';
import Button from '../../common/Button.react';
import Select from '../../common/form/Select.react';

// import ConstantsMetaDataEdit from './ConstantsMetaDataEdit.react';

var MetaDataRoutesTable = function MetaDataRoutesTable(_ref) {
  var selectedApp = _ref.selectedApp,
    metaData = _ref.metaData,
    addModalAction = _ref.addModalAction;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedRoute = _useState2[0],
    setSelectedRoute = _useState2[1];

  // NOTE :: Not the best way of doing things but you need the loop somewhere
  useEffect(function () {
    if (selectedRoute) setSelectedRoute(_objectSpread(_objectSpread({}, selectedRoute), metaData.filter(function (x) {
      return x.id === selectedRoute.id;
    })[0]));
  }, [metaData]);
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Meta Data for :: ".concat(selectedApp.sLabel)
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Label, {
    label: "Select Route"
  }), /*#__PURE__*/React.createElement(Select, {
    value: selectedRoute === null || selectedRoute === void 0 ? void 0 : selectedRoute.sValue,
    options: metaData.filter(function (x) {
      return x.clientApp === selectedApp.sValue;
    }).map(function (x) {
      return _objectSpread(_objectSpread({}, x), {}, {
        sValue: x.route,
        sLabel: x.route
      });
    }),
    onChange: function onChange(e) {
      return setSelectedRoute(e);
    }
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Add Route",
    style: {
      width: '140px',
      marginBottom: '20px'
    },
    onClick: function onClick() {
      addModalAction({
        component: /*#__PURE__*/React.createElement(MetaDataAddRoute, {
          selectedApp: selectedApp.sValue,
          metaData: metaData
        })
      });
    }
  }), selectedRoute && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    label: "Edit Route",
    style: {
      width: '140px',
      marginLeft: '20px'
    },
    onClick: function onClick() {
      addModalAction({
        component: /*#__PURE__*/React.createElement(MetaDataAddRoute, {
          selectedApp: selectedApp.sValue,
          selectedRoute: selectedRoute,
          metaData: metaData
        })
      });
    }
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Add Metadata",
    style: {
      width: '140px',
      marginLeft: '20px'
    },
    onClick: function onClick() {
      addModalAction({
        component: /*#__PURE__*/React.createElement(MetaDataEdit, {
          clientApp: selectedApp.sValue,
          route: selectedRoute.sValue
        })
      });
    }
  })), selectedRoute && /*#__PURE__*/React.createElement(Table, {
    columns: {
      value: 'Tag',
      content: 'Value'
    },
    data: selectedRoute.tags
    // {...tableData}
    // actions={{
    // 	edit: { onEdit: constant => addModal({ constant }) },
    // }}
  })));
};
var mdtp = {
  addModalAction: modalActions.add
};
export default connect(null, mdtp)(MetaDataRoutesTable);

/*



			<CardBody>
				<Table
					{...tableData}
					actions={{
						edit: { onEdit: constant => addModal({ constant }) },
					}}
				/>
				<Button
					label='Add'
					onClick={() => addModal()}
					width='120px'
					style={{ marginTop: 20 }}
				/>
			</CardBody>

*/